import React, { useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";

const ViewMoreButton = ({ sendQuestionRequest, getIdTokenClaims, getAccessTokenWithPopup, logout, clientId, listingDataCount, setListingDataCount, stopLoading }) => {
    const [loading, setLoading] = useState(false);

    // Handler function to toggle showAllListings state
    const toggleShowMoreListings = async () => {
        setLoading(true);
        sendQuestionRequest(getIdTokenClaims, getAccessTokenWithPopup, logout, 'show me more', clientId).then((response) => {
            setListingDataCount({
                returned: 0,
                batch_count: response.data.batch_count
            });
            setTimeout(() => setLoading(false), 10000)
        });
        
    };

    return (
        <div id="viewMoreBtnDiv" className="flex justify-center mb-2">
            <button onClick={toggleShowMoreListings}
                className={`lg:w-fit w-full flex gap-3 px-4 py-4 ms-3 me-3 items-center justify-center rounded-lg
                  ${loading && !stopLoading ? 'bg-[#B6B7B9] disabled' : 'bg-[#0062ff] transition-transform duration-300 hover:scale-105'}`}
                disabled={loading && !stopLoading}
            >
                {
                    loading && !stopLoading
                        ?
                        <div className="flex items-center">
                            <div className="flex space-x-2 px-3 items-center justify-center">
                                <span className="text-white">Loading </span>
                                <div className="w-1 h-1 bg-white rounded-full animate-dot-wave animate-dot-delay-1 mt-[8px]"></div>
                                <div className="w-1 h-1 bg-white rounded-full animate-dot-wave animate-dot-delay-2 mt-[8px]"></div>
                                <div className="w-1 h-1 bg-white rounded-full animate-dot-wave animate-dot-delay-3 mt-[8px]"></div>
                            </div>
                        </div>
                        :
                        <div className="flex items-center gap-2">
                            <span className="text-white">View more</span>
                            <FiArrowUpRight size={22} className="text-sm text-white" />
                        </div>
                }
            </button>
        </div>
    )
}

export default ViewMoreButton;